import { useFlag } from '@calendly/feature-check-react'

import { useFetchTrackedMeetingWithSummariesByForeignIdQuery } from 'hooks/tracked_meetings/api'

/**
 * Resolves meeting-intelligence / recap state for the AI Notes widget (legacy REST+status vs Supergraph detail).
 * Keeps `sa_meetings_page_with_supergraph` branching in one place for easier removal later.
 */
export const useAiNotesMeetingIntelligence = (event) => {
  const supergraphMeetingDetailEnabled = useFlag('sa_meetings_page_with_supergraph', false)
  const mi = event?.meetingIntelligence
  const trackedMeetingUuid = mi?.uuid
  const summaryReady = typeof mi?.summary === 'string' && mi.summary.trim().length > 0

  // Legacy: only MI status (list/detail APIs), not inline summary — avoids extra widget/fetch when list pre-fills summary early.
  const isMiCompleted = supergraphMeetingDetailEnabled
    ? summaryReady
    : mi?.status?.toLowerCase() === 'completed'

  const isRecapInProgress = supergraphMeetingDetailEnabled
    ? false
    : ['meetingended', 'summarizing'].includes(mi?.status?.toLowerCase()?.replace('_', ''))

  const { data: trackedMeeting } = useFetchTrackedMeetingWithSummariesByForeignIdQuery(
    event?.uuid,
    { skip: !event || supergraphMeetingDetailEnabled || !isMiCompleted }
  )

  const summaryForContent = supergraphMeetingDetailEnabled ? mi?.summary : trackedMeeting?.summary
  const showViewRecapLink = !supergraphMeetingDetailEnabled || summaryReady

  return {
    trackedMeetingUuid,
    isMiCompleted,
    isRecapInProgress,
    summaryForContent,
    showViewRecapLink,
  }
}
